import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const deleteSchedule = async (id) => {
  try {
    let { status } = await axios.delete(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/schedule/${id}`);
    if(status === 200){
      addNotification({
        title: "Techforce.ai",
        message: "Schedule has been deleted successfully",
        type: "success"
      });
    }
      
    return status;
  } catch (e) {
    console.log("error while deleting scheule ....", e.response);
    if(e.response){
      let { response: { status }} = e;
      if (status === 405) {
        addNotification({
          title: "Techforce.ai",
          message: "Please write for technical support",
          type: "danger"
        });
      } else if (status === 403) {
        addNotification({
          title: "Techforce.ai",
          message: "You don't have enough permission to delete Schedule",
          type: "danger"
        });
      } 

    }
  }
};
